'use client';

interface OrbitalObjectProps {
  size?: number;
  color?: string;
  orbitDuration?: number;
  orbitRadius?: number;
  delay?: number;
}

export default function OrbitalObject({
  size = 8,
  color = '#4f83ff',
  orbitDuration = 20,
  orbitRadius = 150,
  delay = 0
}: OrbitalObjectProps) {
  return (
    <div
      className="absolute pointer-events-none rounded-full"
      aria-hidden="true"
      style={{
        width: `${size}px`,
        height: `${size}px`,
        background: `radial-gradient(circle at 30% 30%, ${color}, rgba(0,0,0,0))`,
        boxShadow: `0 0 ${size * 2}px ${color}`,
        animation: `orbitalMotion ${orbitDuration}s linear infinite`,
        animationDelay: `${delay}s`,
        willChange: 'transform, opacity',
        '--r': `${orbitRadius}px`,
      } as React.CSSProperties}
    />
  );
}